import Link from '@platform-ui/link';
import cn from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';
import { FormattedMessage as Message } from 'react-intl';
import { ThemedButton } from 'src/templates/webview/ThemedButton';
import useRootElement from '../../hooks/useRootElement';
import styles from './OpeningError.module.css';

export const OpeningError: React.FC<{ isWebview: boolean; onClose: VoidFunction }> = ({ isWebview, onClose }) => {
  const { element, isIframe } = useRootElement();

  return ReactDOM.createPortal(
    <section className={cn(styles.root, isWebview && styles.webview, isIframe && styles.iFrame)}>
      <div className={cn(styles.inner, isIframe && styles.iFrame)}>
        <div className={styles.icon} />

        <div className={styles.text}>
          <span className={styles.header}>
            <Message id={'System.IsOpeningErrorSurvey1'} />
          </span>
          <span className={styles.info}>
            <Message id={'System.IsOpeningErrorSurvey2'} />
            {window.POLL_ERROR_URL && window.POLL_ERROR_TEXT ? (
              <>
                <br />
                <Message id={'System.IsOpeningErrorSurvey3'} />
                <span className={styles.link}>
                  <Link href={window.POLL_ERROR_URL}>{window.POLL_ERROR_TEXT}</Link>
                </span>
              </>
            ) : null}
          </span>
        </div>

        {isWebview && (
          <div className={styles.button}>
            <ThemedButton appearance="secondary" onClick={onClose}>
              <Message id="System.SignOut" />
            </ThemedButton>
          </div>
        )}
      </div>
    </section>,
    element,
  );
};
